module.exports = __webpack_public_path__ + "img/112.77c823bf.jpg";